import { useQuery } from '@tanstack/react-query';
import { request, gql } from 'graphql-request';

import { QueryKeys } from 'src/constants/queryKeys';

import { getLastDayTimestamp } from '@app/helpers/format';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

type AlgebraDayData = {
  volumeUSD: string;
  feesUSD: string;
};

function getQuery() {
  return gql`
    query {
      algebraDayDatas(where: { date_gte: ${getLastDayTimestamp()} }) {
        volumeUSD
        feesUSD
      }
    }
  `;
}

const fetcher = async (config: ApplicationConfig | undefined) => {
  const query = getQuery();

  const res = await request<{ algebraDayDatas: AlgebraDayData[] }>(
    `${config?.URLS.subgraphUrlV3}`,
    query
  );

  return res.algebraDayDatas[0];
};

export function useAmmRecentDailyStats() {
  const config = useConfig();

  return useQuery<AlgebraDayData | undefined>(
    [QueryKeys.AMM_RECENT_DAILY_STATS],
    () => {
      return fetcher(config);
    },
    {
      staleTime: 5000,
      refetchOnWindowFocus: false
    }
  );
}
